// API Configuration for Cyclara Frontend
// In development, Vite proxy handles /api requests
// In production, use the VITE_API_URL environment variable

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export const apiEndpoints = {
  feedback: `${API_BASE_URL}/api/feedback`,
  health: `${API_BASE_URL}/api/health`,
};

export async function apiFetch(endpoint: string, options?: RequestInit): Promise<Response> {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
}
